import { fromJS } from "immutable";
import config from "../config/app.json";
import itemConfig from '../config/itemConfig.json';
import { getImageThumbnailURL, getImageURL } from "./URLHelper";

const appUrl = config['APPICONS'][config['APPICONS']['current']];

export const FRAME_CLASSES = {
    "DROP_AREA": "frame-droppable-area",
    "INNER_IMAGE": "frame-img-item",
}

export const GRID_CLASSES = {
    "DROP_AREA": "grid-droppable-area",
    "INNER_IMAGE": "grid-img-item",
    "BG_COLOR": "grid-bgcolor-item",
}

export const DEFAULT_SELECTED_FRAME_CLIP = fromJS({
    id: "",
    groupId: "",
    clipId: "",
});

const DEFAULT_IMAGE_DETAILS = fromJS({
    src: config.FRAME.DEFAULT_IMAGE,
    width: 1500,
    height: 600
});

const BASE_IMAGE_DETAILS = fromJS({
    src: "",
    thumb: "",
    defaultImageDetails: DEFAULT_IMAGE_DETAILS,
    flipPosition: 0,
    filter: "6464646464640032",
    type: "",
    id: "default",
});

export const calculateAspectRatio = (Frame, Image, clip) => {
    let selectedItem = Frame;

    let imageWidth;
    let imageHeight;

    if (Image !== null) {
        const selectedImage = Image;
        imageWidth = selectedImage.get("width");
        imageHeight = selectedImage.get("height");
    } else {
        imageWidth = selectedItem.getIn(["clipDetails", clip, "imgDetails", "width"]);
        imageHeight = selectedItem.getIn(["clipDetails", clip, "imgDetails", "height"]);
    }
    let imageAspectRatio = imageWidth / imageHeight;

    let frameScale = selectedItem.get("width") / selectedItem.get("defaultWidth");
    let clipWidth = selectedItem.getIn(["clipDetails", clip, "clipWidth"]) * frameScale;
    let clipHeight = selectedItem.getIn(["clipDetails", clip, "clipHeight"]) * frameScale;

    let frameAspectRatio = clipWidth / clipHeight;

    let width,
        height,
        type,
        X = selectedItem.getIn(["clipDetails", clip, "clipX"]) * frameScale,
        Y = selectedItem.getIn(["clipDetails", clip, "clipY"]) * frameScale;

    if (imageAspectRatio < frameAspectRatio) {
        width = clipWidth;
        height = clipWidth * (imageHeight / imageWidth);

        Y = Y + clipHeight / 2 - height / 2;

        type = 1;
    } else if (imageAspectRatio > frameAspectRatio) {
        width = clipHeight * (imageWidth / imageHeight);
        height = clipHeight;

        X = X + clipWidth / 2 - width / 2;

        type = 2;
    } else if (imageAspectRatio === frameAspectRatio) {
        width = clipWidth;
        height = clipHeight;

        X = X + clipWidth / 2 - width / 2;
        Y = Y + clipHeight / 2 - height / 2;

        type = 0;
    }

    let frameHeight = selectedItem.get("height");
    let frameWidth = selectedItem.get("width");

    width = width / frameWidth;
    height = height / frameHeight;
    X = X / frameWidth;
    Y = Y / frameHeight;

    return { width, height, X, Y, type };
}

export const prepareClipDetails = (Frame) => {
    let clipDetails = Frame.get("clipDetails");
    clipDetails.keySeq().forEach((key) => {
                
        Frame = Frame.setIn(["clipDetails", key, "imgDetails"], BASE_IMAGE_DETAILS);
        const { width, height, X: x, Y: y } = calculateAspectRatio(Frame, DEFAULT_IMAGE_DETAILS, key);
        Frame = Frame.setIn(["clipDetails", key, "imgDetails", "original"], fromJS({ width, height, x, y }));
    });

    return Frame.get("clipDetails");
}

export function isVideo(type, subType) {
	try {
		if(type === "STOCKVID" || subType === "UPVIDEO" || type === "VIDEO" || subType === "VIDEO" || subType === "OBGVID") {
			return true;
		}
		return false;
	} catch (error) {
		console.log(error)
	}
}

export const prepareDefaultImgDetails = (Frame, clipId) => {
    let imgDetails = BASE_IMAGE_DETAILS.merge({
        color: Frame.getIn(["clipDetails", clipId, "imgDetails", "color"]),
    });
    Frame = Frame.setIn(["clipDetails", clipId, "imgDetails"], imgDetails);
    const { width, height, X: x, Y: y } = calculateAspectRatio(Frame, DEFAULT_IMAGE_DETAILS, clipId);
    Frame = Frame.setIn(["clipDetails", clipId, "imgDetails", "original"], fromJS({ width, height, x, y }));
    return Frame.getIn(["clipDetails", clipId, "imgDetails"]);
}

export const prepareClipFromWorkspace = ({ Item, ItemId, Frame, clipId, } = {}) => {
    const type = Item.get("type");
    const subType = Item.get("subType");
    const ClipData = Frame.getIn(["clipDetails", clipId]);
    let isVideoObject = isVideo(type, subType);

    const imgDetails = ClipData.getIn(["imgDetails"]);
    let imageData = imgDetails
        .set("subType", subType)
        .set("type", type === "UPVIDEO" ? "UPLOADS" : type)
        .set("width", Item.get("width"))
        .set("height", Item.get("height"))
        .set("assetId", Item.get("assetId"))
        .set("stockId", Item.get("stockId"))
        .set("src", Item.get("src"))
        .set("thumb", Item.get("thumb") || Item.get("thumbnail"))
        .set("stickerify", Item.get("stickerify"))
        .set("strokeOptions", Item.get("strokeOptions"))
        .set("firstEdit", Item.get("firstEdit"))
        .set("isTransparent", Item.get("isTransparent"))
        .set("stickerifyPath", Item.get("stickerifyPath"))
        .set("originalPath", Item.get("originalPath"))
        .set("recentEdit", Item.get("recentEdit"))
        .set("bgremoval", Item.get("bgremoval"))
        .set("bgremovalPath", Item.get("bgremovalPath"))
        .set("id", ItemId)
        .set("colors", Item.get("colors"))
        .set("flipPosition", 0)
        .set("filter", Item.get("filter") || itemConfig["IMAGE"]["DEFAULT_FILTER"])
        .set("defaultColor", Item.get("defaultColor"))
        .set("sourceType", Item.get("sourceType"))
        .set("pwidth", Item.get("pwidth"))
        .set("pheight", Item.get("pheight"));

    if (
        Item.get("isBlob") &&
        Item.get("src") &&
        Item.get("src").startsWith("blob:")
    ) {
        imageData = imageData.remove("thumb");
        imageData = imageData
            .set("isBlob", Item.get("isBlob"))
    }
    if(isVideoObject) {
        imageData = imageData
        .set("videoStart", Item.get("videoStart"))
        .set("videoEnd", Item.get("videoEnd"))
        .set("videoDuration", Item.get("videoDuration"))
        .set("volume", Item.get("volume"))
        .set("duration", Item.get("duration"))
    }

    let imagePlotRatio = calculateAspectRatio(
        Frame,
        imageData,
        clipId,
    );

    imageData = imageData.set("original", fromJS({
        x: imagePlotRatio.X,
        y: imagePlotRatio.Y,
        width: imagePlotRatio.width,
        height: imagePlotRatio.height,
    }));

    return imageData;
}

export const getImageSource = (item, id) => {
    if (
        item.get("isBlob")
        && item.get("src")
        && item.get("src").startsWith("blob:")
    ) { // blob image
        return {
            src: item.get("src"),
            thumb: item.get("src"),
        }
    }

    let src = getImageURL(item, id);
    let thumbSrc = item.get("thumb") || item.get("thumbnail")
    let thumb = getImageThumbnailURL(item.get("type"), item.get("subType"), thumbSrc);

    if (item.get('stickerify') || item.get('bgremoval')) {
        src = config.UPLOADS[config.UPLOADS.workspace_UPIMAGE] + item.get("src");
        thumb = `${appUrl}/images/chr-loading.svg`;
    }

    return {
        src: src,
        thumb: thumb,
    }
}

export const getFrameAssets = ({ frameItem, canInclude = undefined }) => {
    let assets = [];
    let ignoreList = [];

    frameItem.get("clipDetails").forEach((clip) => {
        let src = undefined;
        let type = clip.getIn(["imgDetails", "type"]);
        let subType = clip.getIn(["imgDetails", "subType"])
        if(type === "STOCKVID" || (type === "UPLOADS" && subType === "UPVIDEO") || subType === "VIDEO" || subType === "OBGVID") {
            return []
        }
        if (clip.getIn(["imgDetails", "id"]) !== BASE_IMAGE_DETAILS.get("id")) { // image is dropped
            if (
                clip.getIn(["imgDetails", "type"]) !== "STOCKIMG"
                && clip.getIn(["imgDetails", "subType"]) !== "IMAGE"
            ) {
                src = getImageSource(clip.get("imgDetails")).src;
            }
        } else {
            src = `${appUrl}${clip.getIn(["imgDetails", "defaultImageDetails", "src"])}`;
        }

        if (
            src
            && !assets.includes(src)
            && !ignoreList.includes(src)
        ) {
            if (typeof canInclude === "function") {
                if (canInclude(src)) {
                    assets.push(src);
                } else {
                    ignoreList.push(src);
                }
            } else {
                assets.push(src);
            }
        }
    });

    return assets;
}

export const getFrameDropAreaId = (id, clipId, idPrefix = "") => {
    return idPrefix + id + "_droppable_area_" + clipId;
}

export const getGridDropAreaId = (id, clipId, idPrefix = "") => {
    return idPrefix + id + "_droppable_container_" + clipId;
}

export const getFrameSvgId = (id, svgIndex, idPrefix = "") => {
    return idPrefix + id + "_svg_" + svgIndex;
}

export const getFrameClipFilterSvgId = (id, clipId, idPrefix = "") => {
    return idPrefix + id + "_svgFilter_" + clipId;
}

export const getFrameClipFilterId = (id, clipId, filterId, idPrefix = "") => {
    return idPrefix + id + "_svgFilter_" + clipId + "_" + filterId;
}

export const getFrameClipVignetteId = (id, clipId, idPrefix = "") => {
    return idPrefix + id + "-vignette-" + clipId;
}

export function getCellStyle(itemWidth, itemHeight, cellId) {
    return {
        width: itemWidth,
        height: itemHeight,
        gridArea: cellId,
    };
}



// WEBPACK FOOTER //
// ./src/helpers/frameHelper.js